// URL base da API
const API_BASE_URL = process.env.REACT_APP_API_URL;

// Função auxiliar para obter o token de autenticação do localStorage
const getAuthToken = (): string | null => {
  try {
    return localStorage.getItem('authToken');
  } catch (error) {
    console.error('Erro ao obter token de autenticação:', error);
    return null;
  }
};

// Função para criar headers com token de autenticação
const getAuthHeaders = (): HeadersInit => {
  const token = getAuthToken();
  const headers: HeadersInit = {};
  
  if (token) {
    // Garantir que o token seja passado no header Authentication
    headers['Authentication'] = `Bearer ${token}`;
    // Manter também no Authorization para compatibilidade
    headers['Authorization'] = `Bearer ${token}`;
  } else {
    console.warn('Token de autenticação não encontrado no localStorage');
  }
  
  return headers;
};

// Interface para cidades
export interface City {
  name: string;
  ibgeCity: number;
}

// Interface para resposta da API
export interface AddressResponse {
  ibgeState: number;
  cities: City[];
}

/**
 * Serviço para busca de endereços
 */
export const addressService = {
  /**
   * Busca cidades por UF usando o endpoint interno do backend
   * @param uf - Unidade Federativa (Ex: MG, SP, RJ)
   * @returns Promise com a lista de cidades
   */
  getCitiesByUF: async (uf: string): Promise<City[]> => {
    try {
      console.log(`Buscando cidades para UF: ${uf}`);
      
      // Adicionar headers de autenticação
      const headers = getAuthHeaders();
      console.log('Headers de autenticação:', headers);

      // Fazer requisição para o endpoint interno do backend
      const response = await fetch(`${API_BASE_URL}/api/v1/ibge/uf?uf=${encodeURIComponent(uf)}`, {
        method: 'GET',
        headers: headers
      });

      // Verificar se houve erro na requisição
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Não foi possível carregar a lista de cidades. Por favor, tente novamente.');
      }

      // Processar resposta
      const data = await response.json();
      
      // O endpoint interno retorna os dados no campo body como string JSON
      // Verificar se o campo body existe e convertê-lo de string para objeto, se necessário
      if (data.body && typeof data.body === 'string') {
        const parsedBody = JSON.parse(data.body);
        return parsedBody.cities || [];
      } else if (data.body && data.body.cities) {
        return data.body.cities;
      } else if (data.cities && Array.isArray(data.cities)) {
        return data.cities;
      }
      
      // Se não encontrar cities, retornar array vazio
      console.warn('Resposta não contém campo cities válido:', data);
      return [];
    } catch (error) {
      console.error('Erro ao buscar cidades:', error);
      throw error;
    }
  }
};
